import EDPanel from '../../../../../BaseComponents/Panel/EDPanel';
import EDIcon from '../../../../../BaseComponents/Icon/EDIcon';
import Tasks from '../../../../../Components/Tasks/Tasks';

const TasksPanel = () => (
  <EDPanel
    title="Arbetsuppgifter"
    avatar={<EDIcon color="action" iconType="assignment" size="large" />}
    headerPadding="normal"
    flex
  >
    <Tasks />
  </EDPanel>
);

export default TasksPanel;
